import { DamPermissionsMap } from './dam/dam.permissions'
import { Injectable } from '@angular/core'
import { PermissionConfig, PermissionsGuard } from '@surgetech-eu/core'

@Injectable()
export class AppPermissionsGuard extends PermissionsGuard {
    getPermissionMap(): PermissionConfig[] {
        return [
            ...DamPermissionsMap,
            {
                requiredAction: 'accessEverythingExceptDam',
                menuItemNames: [
                    'prepare',
                    'manage',
                    'link',
                    'assign',
                    'propose',
                    'certification',
                    'history',
                    'versioning-history',
                    'linked',
                    'catalog',
                    'sap-integration',
                    'value-chain',
                    'suggested-measures',
                    'audit',
                    'baseMaterial',
                    'secondary-packaging',
                    'packaging-material',
                    'prepare-manage-packaging-item',
                    'packaging-item-view',
                    'packaging-kit-view',
                    'prepare-manage-packaging-kit',
                    'techDesign',
                    'component',
                    'galvman',
                    'galvanicTreatment',
                    'galvanicTreatmentPrepare',
                    'galvanicTreatmentManage',
                    'galvanicTreatmentView',
                    'galvmanPlatingMaterials',
                    'galvmanDataSheets',
                    'galvmanHistory',
                    'galvmanCertification',
                    'galvmanSelectAndCreate',
                    'galvmanUploadAndCreate',
                    'galvmanPlayer',
                    'galvmanView',
                    'galvmanPlatingMaterial'
                ],
                urlMasks: [
                    '/catalog/**',
                    '/settings/**',
                    '/eyewear/**',
                    '/case/**',
                    '/sap-integration/**',
                    '/history/**',
                    '/value-chain/**',
                    '/suggested-measures/**',
                    '/audit/**',
                    '/mapping/**',
                    '/secondary-packaging/**',
                    '/tech-drawing/**',
                    '/component/**',
                    '/galvman/**'
                ]
            },
            {
                urlMasks: '',
                requiredAction: 'accessEverythingExceptDam',
                redirectUrl: '/dam/product-images'
            },
            {
                urlMasks: '/user-management',
                requiredAction: 'manageUsers',
                menuItemNames: 'user-management'
            }
        ]
    }
}
